import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["tabindex", "aria-expanded"]
const _hoisted_2 = ["onClick"]

import mediaGalleryImage from "./common/media-gallery-image.vue";
//import mediaGalleryTransition from "./media-gallery-transition.vue";
import {
    computed,
    type ObjectDirective,
    onMounted,
    ref,
    watch,
    type PropType,
    onBeforeUnmount,
} from "vue";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import mediaGalleryView from "./big-frame/media-gallery-view.vue";
import { type MediaBase, type MediaItem } from "./types";
import fastdom from "fastdom";
import { debounce } from "lodash";
import ImageArrow from "./big-frame/image-arrow.vue";

type ParsedItem = { key: number; firstSelectable: boolean } & MediaItem;

function isEmptyText(sibling: Node): boolean;
function isEmptyText(sibling: null | undefined): false;

const __default__ = {
    name: "media-gallery",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {
        type: Array as PropType<MediaItem[]>,
        required: true,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    vertical: {
        type: Boolean,
        default: false,
    },
    expandEnabled: Boolean,
    hasAnotherViewOpen: Boolean,
    showArrows: Boolean,
    enableArrowKeys: Boolean,
},
  emits: ["expand", "close"],
  setup(__props, { emit: __emit }) {

function isEmptyText(sibling: Node | null | undefined): boolean {
    if (sibling != null) {
        if (
            sibling.nodeType === sibling.TEXT_NODE &&
            (sibling.textContent?.trim() ?? "") === ""
        ) {
            return true;
        }
    }
    return false;
}

const vDragByMouse: ObjectDirective<HTMLElement> = {
    mounted: function (el) {
        el.addEventListener("dragstart", function (dragStartEvent) {
            //console.log("dragStart");
            dragStartEvent.preventDefault();
            el.classList.add("dragging");
            const initialX = dragStartEvent.clientX;
            const initialY = dragStartEvent.clientY;
            const initialScrollTop = el.scrollTop;
            const initialScrollLeft = el.scrollLeft;

            const setPos = function (
                event: PointerEvent | MouseEvent | DragEvent
            ) {
                const newValueTop =
                    initialScrollTop + (initialY - event.clientY);
                const newValueLeft =
                    initialScrollLeft + (initialX - event.clientX);
                el.scrollTop = newValueTop;
                el.scrollLeft = newValueLeft;
            };

            const endListeners: {
                name: string;
                func: EventListenerOrEventListenerObject;
            }[] = [];

            const moveHandleEventName = "mousemove";

            const endTracking = function () {
                el.removeEventListener(moveHandleEventName, dragHandler);
                el.classList.remove("dragging");
                for (const item of endListeners) {
                    el.removeEventListener(item.name, item.func);
                }
            };

            el.addEventListener(moveHandleEventName, dragHandler);

            const mouseUpEventHandler = function (dragEndEvent: DragEvent) {
                endTracking();
                setPos(dragEndEvent);
            } as EventListener;
            endListeners.push({
                name: "mouseup",
                func: mouseUpEventHandler,
            });
            el.addEventListener("mouseup", mouseUpEventHandler, {
                once: true,
            });

            function dragHandler(dragEvent: Event) {
                dragEvent.preventDefault();

                if ((dragEvent as DragEvent).buttons == 0) {
                    endTracking();
                    return;
                }

                setPos(dragEvent as DragEvent);
            }
        });
    },
};
const vNoWhitespaces: ObjectDirective<HTMLElement> = {
    mounted: function (el) {
        if (el.nextSibling != null && isEmptyText(el.nextSibling)) {
            el.nextSibling.remove();
        }
        if (el.previousSibling != null && isEmptyText(el.previousSibling)) {
            el.previousSibling.remove();
        }
    },
};
const props = __props;

const emit = __emit;

const mappedData = ref(createMappedData(props.value));
const selectedIndex = ref<undefined | number>(0);
const fallbackImageUrl = "data:image/gif;base64,R0lGODlhAQABAAAAADs=";
const thumbnailContainerWidthValue = ref<number>();
const thumbnailContainerHeightValue = ref<number>();
const breakpointObserver = getBreakpointObservable();
const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});

function expandIfEnabled(event: Event) {
    if (!props.expandEnabled) {
        event.preventDefault();
        return;
    }
    emit("expand");
}

const itemSize = computed(() => {
    let width = 108;
    let height = 81;

    if (currentBreakpoint.value != null && currentBreakpoint.value.up("lg")) {
        width = 100;
        height = 75;
    }

    return {
        width,
        height,
    };
});

const selectedItem = computed(() => {
    if (mappedData.value == null) return null;
    if (selectedIndex.value == null) return null;
    return mappedData.value[selectedIndex.value];
});
// const thumbnailContainerWidth = computed(() => {
//     if (thumbnailContainerWidthValue.value == null)
//         return thumbnailContainerWidthValue.value;
//     return thumbnailContainerWidthValue.value + "px";
// });
// const thumbnailContainerHeight = computed(() => {
//     if (thumbnailContainerHeightValue.value == null)
//         return thumbnailContainerHeightValue.value;
//     return thumbnailContainerHeightValue.value + "px";
// });
const thumbnailContainerStyle = computed(() => {
    if (props.vertical) {
        return {
            "margin-right": spacerSize.value + "px",
            width: itemSize.value.width + "px",
        };
    } else {
        return {
            "margin-top": spacerSize.value + "px",
            height: itemSize.value.height + "px",
        };
    }
});
const thumbnailListStyle = computed(() => {
    return {};
});
const spacerSize = computed(() => {
    let limit: number;
    let itemSiz: number;
    if (props.vertical) {
        limit = thumbnailContainerHeightValue.value ?? 0;
        itemSiz = itemSize.value.height;
    } else {
        limit = thumbnailContainerWidthValue.value ?? 0;
        itemSiz = itemSize.value.width;
    }

    const division = limit / itemSiz;
    const itemsToShow = Math.floor(division);
    const remainder = division % 1;
    let spacerSize = (remainder * itemSiz) / (itemsToShow - 1);

    if (spacerSize < 5) spacerSize = 5;
    if (spacerSize > 15) spacerSize = 15;
    return spacerSize;
});
const thumbnailSpacerStyle = computed(() => {
    if (props.vertical) {
        return { width: "", height: spacerSize.value + "px" };
    } else {
        return { width: spacerSize.value + "px", height: "" };
    }
});
const thumbnailItemStyle = computed(() => {
    return {
        height: itemSize.value.height + "px",
        width: itemSize.value.width + "px",
    };
});

onMounted(() => {
    window.addEventListener("resize", () => {
        resizeEventHandler(/* "window resize" */);
    });
    updateSizing(/* "mounted" */);
});

function resizeEventHandler(/* source */) {
    updateSizing(/* source */);
}
const deboncedSetSizeForContainer = debounce(() => {
    fastdom.measure(() => {
        setSizeForThumbnailContainer();
    });
});
function updateSizing() {
    //console.log("UPDATE SIZING FROM "+src+" "+ performance.now());
    deboncedSetSizeForContainer();
}
const frame = ref<HTMLElement>();
function setSizeForThumbnailContainer() {
    let width = thumbnailContainerWidthValue.value;
    let height = thumbnailContainerHeightValue.value;

    const fr = frame.value;
    if (fr == null || !(fr instanceof HTMLElement)) throw new Error("no frame");
    const frameBoundRect = fr.getBoundingClientRect();
    if (props.vertical) {
        width = undefined;
        height = frameBoundRect.height;
    } else {
        width = frameBoundRect.width;
        height = undefined;
    }

    thumbnailContainerWidthValue.value = width;
    thumbnailContainerHeightValue.value = height;

    //console.log("NEW SIZE",width,height);
}

const thumbnailList = ref<HTMLElement>();
const thumbnailItems = ref<HTMLElement[]>();

function previousImage() {
    relImage(-1);
}

function nextImage() {
    relImage(1);
}

function relImage(rel: number) {
    if (selectedIndex.value == null) return;
    if (mappedData.value == null) return;
    const newIndex =
        (mappedData.value.length + selectedIndex.value + rel) %
        mappedData.value.length;
    selectImage(mappedData.value[newIndex], thumbnailItems.value?.[newIndex]);
}

function selectImage(
    item: ParsedItem,
    element: EventTarget | undefined | null = null
) {
    if (item.selectable === false) return;
    if (element != null && element instanceof HTMLElement) {
        const thumbList = thumbnailList.value;
        if (thumbList == null || !(thumbList instanceof HTMLElement))
            throw new Error("missing thumbnail list");
        if (props.vertical) {
            thumbList.scrollTop =
                element.offsetTop +
                thumbList.offsetHeight / 2 +
                element.offsetHeight / 2 -
                thumbList.offsetHeight;
            //element.scrollIntoView({ behaviour: "smooth", block: "center", inline: "nearest" });
        } else {
            thumbList.scrollLeft =
                element.offsetLeft +
                thumbList.offsetWidth / 2 +
                element.offsetWidth / 2 -
                thumbList.offsetWidth;
            //element.scrollIntoView({ behaviour: "smooth", block: "nearest", inline: "center" });
        }
    }
    selectedIndex.value = mappedData.value.indexOf(item);
}
function createMappedData(data: MediaItem[]): ParsedItem[] {
    if (data == null) return data;
    const firstSelectable = data.findIndex((x) => x.selectable !== false);
    return data.map((x, i) =>
        Object.assign({}, x, {
            key: i,
            firstSelectable: firstSelectable === i,
            thumbnail: getThumbnailForItem(x),
        })
    );
}
function getThumbnailForItem(item: MediaItem) {
    let thumbnail = null;
    if (item.thumbnail != null) thumbnail = item.thumbnail;
    else thumbnail = item;
    if (thumbnail == null) return null;
    if (
        typeof thumbnail === "string" ||
        ("type" in thumbnail && thumbnail.type === "picture")
    )
        return thumbnail;
    return null;
}
function getNewIndex(mapData: MediaBase[] | undefined | null, index: number) {
    if (mapData == null) return;
    if (index < 0) index = 0;
    if (mapData.length == 0) index = 0;
    else if (index >= mapData.length) index = mapData.length - 1;
    while (mapData[index] != null && mapData[index].selectable === false) {
        index++;
        if (mapData[index] == null) {
            index = -1;
            break;
        }
    }
    return index;
}

watch(
    () => props.value,
    (newValue) => {
        mappedData.value = createMappedData(newValue);
    }
);

watch(
    () => mappedData.value,
    (newValue) => {
        selectedIndex.value = getNewIndex(newValue, selectedIndex.value ?? 0);
    },
    { immediate: true }
);

const boundArrowKeys = ref(false);

function globalKeyHandler(ev: KeyboardEvent) {
    if (ev.ctrlKey || ev.metaKey || ev.shiftKey) {
        return;
    }
    if (ev.key === "ArrowLeft" || ev.key == "ArrowUp") {
        previousImage();
        ev.preventDefault();
    } else if (ev.key === "ArrowRight" || ev.key == "ArrowDown") {
        nextImage();
        ev.preventDefault();
    } else if (ev.key === "Escape") {
        emit("close");
    } else {
        console.log(ev.key);
    }
}

function bindKeyEvents(bind: boolean) {
    if (bind && !boundArrowKeys.value) {
        window.addEventListener("keydown", globalKeyHandler);
        boundArrowKeys.value = bind;
    } else if (!bind && boundArrowKeys.value) {
        window.removeEventListener("keydown", globalKeyHandler);
        boundArrowKeys.value = bind;
    }
}

watch(
    () => props.enableArrowKeys,
    (newValue) => {
        console.log("bindKeyEvents(" + newValue + ")");
        bindKeyEvents(newValue);
    },
    { immediate: true }
);
onBeforeUnmount(() => {
    bindKeyEvents(false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            _ctx.$style[__props.vertical ? 'vertical' : 'horizontal'],
            __props.fullWidth ? _ctx.$style['full-width'] : '',
            _ctx.$style['media-gallery'],
        ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style['image-frame-container']])
    }, [
      (__props.showArrows)
        ? (_openBlock(), _createBlock(ImageArrow, {
            key: 0,
            mode: "prev",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (previousImage()))
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass([
                    _ctx.$style['image-frame'],
                    __props.expandEnabled ? _ctx.$style['image-frame--expand-enabled'] : '',
                ]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (expandIfEnabled($event))),
        onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (expandIfEnabled($event)), ["enter"])),
        tabindex: __props.expandEnabled ? '0' : undefined,
        "aria-expanded": 
                    __props.expandEnabled ? `${__props.hasAnotherViewOpen}` : undefined
                ,
        ref_key: "frame",
        ref: frame
      }, [
        (__props.expandEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['expand-overlay'])
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "64",
                height: "64",
                fill: "currentColor",
                viewBox: "-1 -1 17 17"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0",
                  stroke: "currentColor",
                  "stroke-width": "1px"
                }),
                _createElementVNode("path", { d: "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" }),
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
                })
              ], -1 /* HOISTED */)
            ]), 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createVNode(mediaGalleryView, {
          "expand-enabled": __props.expandEnabled,
          onExpand: _cache[1] || (_cache[1] = ($event: any) => (emit('expand'))),
          key: "null",
          item: undefined,
          selected: selectedItem.value == null
        }, null, 8 /* PROPS */, ["expand-enabled", "selected"]), [
          [_vShow, selectedItem.value == null]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappedData.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.selectable !== false)
              ? _withDirectives((_openBlock(), _createBlock(mediaGalleryView, {
                  "expand-enabled": __props.expandEnabled,
                  onExpand: _cache[2] || (_cache[2] = ($event: any) => (emit('expand'))),
                  key: item.key,
                  lazy: item.key > 0 && item.firstSelectable == false,
                  item: item,
                  selected: selectedItem.value == item
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                  (item.firstSelectable === true)
                    ? {
                        name: "after-image",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "after-first-image")
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["expand-enabled", "lazy", "item", "selected"])), [
                  [_vShow, selectedItem.value == item]
                ])
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _renderSlot(_ctx.$slots, "inside-frame")
      ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1),
      _renderSlot(_ctx.$slots, "under-image"),
      (__props.showArrows)
        ? (_openBlock(), _createBlock(ImageArrow, {
            key: 1,
            mode: "next",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (nextImage()))
          }))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      style: _normalizeStyle(thumbnailContainerStyle.value),
      class: _normalizeClass(_ctx.$style['thumbnail-container'])
    }, [
      _withDirectives((_openBlock(), _createElementBlock("ul", {
        class: _normalizeClass(_ctx.$style['thumbnails']),
        style: _normalizeStyle(thumbnailListStyle.value),
        ref_key: "thumbnailList",
        ref: thumbnailList
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappedData.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.key
          }, [
            (item !== mappedData.value[0])
              ? _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style['thumbnail-spacer']),
                  style: _normalizeStyle(thumbnailSpacerStyle.value)
                }, null, 6 /* CLASS, STYLE */)), [
                  [vNoWhitespaces]
                ])
              : _createCommentVNode("v-if", true),
            _withDirectives((_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([
                            _ctx.$style['thumbnail-item'],
                            item === selectedItem.value ? _ctx.$style['selected'] : '',
                        ]),
              ref_for: true,
              ref_key: "thumbnailItems",
              ref: thumbnailItems,
              style: _normalizeStyle(thumbnailItemStyle.value),
              onClick: ($event: any) => (selectImage(item, $event.target))
            }, [
              _createVNode(mediaGalleryImage, {
                value: 
                                item.thumbnail != null
                                    ? typeof item.thumbnail == 'string'
                                        ? item.thumbnail
                                        : item.thumbnail.src
                                    : fallbackImageUrl
                            ,
                size: 
                                item.thumbnail != null &&
                                typeof item.thumbnail != 'string'
                                    ? item.thumbnail.size
                                    : undefined
                            ,
                sources: 
                                item.thumbnail != null &&
                                typeof item.thumbnail != 'string'
                                    ? item.thumbnail.sources
                                    : undefined
                            ,
                alt: 
                                item.thumbnail != null &&
                                typeof item.thumbnail != 'string'
                                    ? item.thumbnail.alt
                                    : undefined
                            ,
                srcset: 
                                item.thumbnail != null &&
                                typeof item.thumbnail != 'string'
                                    ? item.thumbnail.srcset
                                    : undefined
                            
              }, null, 8 /* PROPS */, ["value", "size", "sources", "alt", "srcset"])
            ], 14 /* CLASS, STYLE, PROPS */, _hoisted_2)), [
              [vNoWhitespaces]
            ])
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 6 /* CLASS, STYLE */)), [
        [vDragByMouse]
      ])
    ], 6 /* CLASS, STYLE */)
  ], 2 /* CLASS */))
}
}

})